import React, { useState } from 'react'
import { navigate } from "@reach/router";
import { Form, FormControl } from "react-bootstrap";

const SearchArticulo = ({ wider, center }) => {
    const [searchString, setSearchString] = useState("");

    return <>
        <Form
            inline
            onSubmit={(e) => {
                e.preventDefault();
                //   if (searchResult && searchResult.length > 0) {
                //     navigate(encodeURI("/articulo/" + searchResult[0].nombre));
                //   }
            }}
        >
            {/* <Dropdown
              navbar
              show={showDropdown}
              alignRight
              onToggle={(newVal) => setShowDropdown(newVal)}
            >
              <Dropdown.Toggle
                bsPrefix="searchbar"
                variant="success"
                id="dropdown-search"
                as={"span"}
              > */}
            <FormControl
                style={{ marginLeft: center ? 'auto' : null, marginRight: center ? 'auto' : null, width: wider ? 300 : null, backgroundColor: '#1b1b1b', color: '#aaa', border: '1px solid rgba(0,0,0,0.6)', }}
                type="text"
                placeholder="Buscar Artículo"
                // className="mr-sm-2"
                onChange={(e) => {
                    setSearchString(e.target.value)
                    // search(e.target.value);
                    // setShowDropdown(true);
                }}
                onKeyPress={(event) => {
                    if (event.key === 'Enter') {
                        navigate("/buscar/", { state: { searchString } })
                    }
                }}
            />
            {/* </Dropdown.Toggle>
              <Dropdown.Menu>
                {(!searchResult || searchResult.length < 1) && (
                  <Dropdown.Item disabled>Resultados:</Dropdown.Item>
                )}
                {searchResult &&
                  searchResult.map((el) => (
                    <Dropdown.Item
                      onClick={() => {
                        navigate(encodeURI("/articulo/" + el.nombre));
                      }}
                    >
                      {el.titulo}
                    </Dropdown.Item>
                  ))}
              </Dropdown.Menu>
            </Dropdown> */}
        </Form>
    </>
}

export default SearchArticulo